<ng-template #view>
  <table>
    <tr>
      <td>
        <span class="item-label" [class.start]="isStart()" [class.end]="!isStart()">
          @if (isStart()) {
            <span>
              {{ translation.reservationPopup.start | transloco }}
            </span>
          }
          @if (!isStart()) {
            <span>
              {{ translation.reservationPopup.end | transloco }}
            </span>
          }
        </span>
      </td>
      <td>
        <span class="date-text">
          {{ dateTime() | dateFormat }}
        </span>
      </td>
    </tr>
  </table>

  <p class="time">
    {{ dateTime() | timeFormat }}
    @if (editable()) {
      <cue-icon [icon]="cuePencil" />
    }
  </p>
</ng-template>

@if (editable()) {
  <cue-editable #editable (edit)="onEdit()" class="editable">
    <ng-template viewMode>
      <ng-container *ngTemplateOutlet="view" />
    </ng-template>
    <ng-template editMode>
      <assist-datetimepicker
        #picker
        [formControl]="control"
        [format]="pipesService.dateTimeFormat"
        [min]="min()"
        [max]="max()"
        [steps]="steps"
        [popupSettings]="{
          appendTo: 'component',
        }"
      />
    </ng-template>
  </cue-editable>
}

@if (!editable()) {
  <ng-container *ngTemplateOutlet="view" />
}
